import _default from './Responsive';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/Responsive/index.js
// module id = 2681
// module chunks = 1